import { useCallback } from 'react';

import {
  DEFAULT_TOKEN_INPUT,
  useTradeModuleStore,
  type TokenInputValues,
  type TradeModuleStore,
} from './store';

const tradeInputsSelector = (state: TradeModuleStore) => ({
  sellInput: state.sellInput,
  buyInput: state.buyInput,
  updateSellInput: state.updateSellInput,
  updateBuyInput: state.updateBuyInput,
  setInputMode: state.setInputMode,
  switchInputs: state.switchInputs,
});

/**
 * The view-facing write contract for trade inputs. Update callbacks default
 * omitted values to `DEFAULT_TOKEN_INPUT` because the shared
 * `AmountInputGroup` invokes them without arguments to reset a side.
 */
export function useTradeInputs() {
  const { sellInput, buyInput, updateSellInput, updateBuyInput, setInputMode, switchInputs } =
    useTradeModuleStore(tradeInputsSelector);

  const updateSell = useCallback(
    (value: TokenInputValues = DEFAULT_TOKEN_INPUT) => updateSellInput(value),
    [updateSellInput],
  );
  const updateBuy = useCallback(
    (value: TokenInputValues = DEFAULT_TOKEN_INPUT) => updateBuyInput(value),
    [updateBuyInput],
  );
  const updateInputs = useCallback(
    (buy: TokenInputValues = DEFAULT_TOKEN_INPUT, sell: TokenInputValues = DEFAULT_TOKEN_INPUT) => {
      updateBuyInput(buy);
      updateSellInput(sell);
    },
    [updateBuyInput, updateSellInput],
  );

  return {
    sellInput,
    buyInput,
    setInputMode,
    switchInputs,
    updateSellInput: updateSell,
    updateBuyInput: updateBuy,
    updateInputs,
  };
}
